import { render, staticRenderFns } from "./echarts.vue?vue&type=template&id=4ae64dd4&scoped=true"
import script from "./echarts.vue?vue&type=script&lang=js"
export * from "./echarts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae64dd4",
  null
  
)

export default component.exports